
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/didattica",
      function () {
        return require("private-next-pages/didattica/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/didattica"])
      });
    }
  